export default {"src":"/_next/static/media/simle-face.df5cdb35.svg","height":34,"width":34};